export type KelompokAuditPembersihanLingkungan = "A" | "B" | "C" | "D" | "E";

export type PenilaianAuditPembersihanLingkungan = "ya" | "tidak";

export type KategoriAuditPembersihanLingkungan = "sangat_baik" | "baik" | "cukup_kurang";

export interface KriteriaAuditPembersihanLingkungan {
  no: number;
  no_label: string;
  kelompok: KelompokAuditPembersihanLingkungan;
  kriteria: string;
  dasar_regulasi: string;
}

export const AUDIT_PEMBERSIHAN_LINGKUNGAN_PRIVILEGE = "audit_pembersihan_lingkungan";

export const KELOMPOK_AUDIT_PEMBERSIHAN_LINGKUNGAN: Record<KelompokAuditPembersihanLingkungan, string> = {
  A: "Alat Pelindung Diri (APD) & Higiene Tangan",
  B: "Peralatan & Cairan Pembersih",
  C: "Prosedur & Teknik Pembersihan",
  D: "Fokus Area Permukaan Sentuh Tinggi (High-Touch Surfaces)",
  E: "Pengelolaan Pasca-Pembersihan"
};

export const KRITERIA_AUDIT_PEMBERSIHAN_LINGKUNGAN: KriteriaAuditPembersihanLingkungan[] = [
  {
    no: 1,
    no_label: "1",
    kelompok: "A",
    kriteria: "Petugas melakukan kebersihan tangan sebelum dan sesudah tindakan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — kebersihan tangan)"
  },
  {
    no: 2,
    no_label: "2",
    kelompok: "A",
    kriteria:
      "Petugas menggunakan APD sesuai indikasi (sarung tangan rumah tangga, masker, apron)",
    dasar_regulasi: "Permenkes 27/2017 (PPI — APD)"
  },
  {
    no: 3,
    no_label: "3",
    kelompok: "A",
    kriteria: "APD dilepas dan dibuang/didekontaminasi dengan benar setelah selesai",
    dasar_regulasi: "Permenkes 27/2017 (PPI — APD)"
  },
  {
    no: 4,
    no_label: "4",
    kelompok: "B",
    kriteria: "Microfiber/kain lap dibedakan berdasarkan zona warna (color coding)",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 5,
    no_label: "5",
    kelompok: "B",
    kriteria: "Cairan disinfektan diencerkan sesuai dosis/instruksi pabrik",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 6,
    no_label: "6",
    kelompok: "B",
    kriteria:
      "Wadah cairan disinfektan diberi label (nama cairan, tanggal pembuatan, kedaluwarsa)",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 7,
    no_label: "7",
    kelompok: "B",
    kriteria:
      "Ember pembersih menggunakan sistem double bucket / pemisahan air bersih & kotor",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 8,
    no_label: "8",
    kelompok: "C",
    kriteria: "Pembersihan dilakukan dari area bersih ke area kotor",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 9,
    no_label: "9",
    kelompok: "C",
    kriteria: "Pembersihan dilakukan dari atas ke bawah (tinggi ke rendah)",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 10,
    no_label: "10",
    kelompok: "C",
    kriteria:
      "Teknik mengelap/mengepel menggunakan satu arah gosokan (S-shape / melipat kain)",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 11,
    no_label: "11",
    kelompok: "C",
    kriteria: "Kain lap tidak dicelup ulang ke wadah cairan bersih setelah digunakan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 12,
    no_label: "12",
    kelompok: "C",
    kriteria:
      "Waktu kontak (wetted dwell time) disinfektan terpenuhi sesuai standar produk",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 13,
    no_label: "13",
    kelompok: "D",
    kriteria: "Bed rail (pembatas tempat tidur) dan tombol pengatur bed dibersihkan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 14,
    no_label: "14",
    kelompok: "D",
    kriteria:
      "Sakelar lampu, bel pemanggil (nurse call), dan gagang pintu dibersihkan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 15,
    no_label: "15",
    kelompok: "D",
    kriteria: "Meja pasien (overbed table), nakas, dan remote TV/AC dibersihkan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 16,
    no_label: "16",
    kelompok: "D",
    kriteria: "Tiang infus, tiang monitor, dan komod/kursi pasien dibersihkan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 17,
    no_label: "17",
    kelompok: "D",
    kriteria: "Keran air, dispenser sabun, dan pegangan toilet dibersihkan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 18,
    no_label: "18",
    kelompok: "E",
    kriteria:
      "Kain lap dan kepala pel kotor dicuci serta dikeringkan setelah digunakan",
    dasar_regulasi: "Permenkes 27/2017 (PPI — pengendalian lingkungan)"
  },
  {
    no: 19,
    no_label: "19",
    kelompok: "E",
    kriteria:
      "Peralatan kebersihan disimpan di gudang sanitasi dalam keadaan bersih & kering",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 20,
    no_label: "20",
    kelompok: "E",
    kriteria: "Limbah medis dan non-medis dibuang sesuai tempatnya",
    dasar_regulasi:
      "Permenkes 7/2019 (Kesling RS — pengamanan limbah); Permenkes 27/2017 (PPI)"
  }
];

export const APL_ITEM_COUNT = KRITERIA_AUDIT_PEMBERSIHAN_LINGKUNGAN.length;

export const AMBANG_SANGAT_BAIK = 85;
export const AMBANG_BAIK = 76;

export const KATEGORI_AUDIT_PEMBERSIHAN_LINGKUNGAN: Record<
  KategoriAuditPembersihanLingkungan,
  { label: string; color: string }
> = {
  sangat_baik: { label: "SANGAT BAIK", color: "success" },
  baik: { label: "BAIK", color: "warning" },
  cukup_kurang: { label: "CUKUP/KURANG", color: "error" }
};

export function kategoriAuditPembersihanLingkungan(
  rate: number | null
): KategoriAuditPembersihanLingkungan | null {
  if (rate === null) return null;
  if (rate >= AMBANG_SANGAT_BAIK) return "sangat_baik";
  if (rate >= AMBANG_BAIK) return "baik";
  return "cukup_kurang";
}

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS: {
  text: string;
  value: PenilaianAuditPembersihanLingkungan;
  color: string;
  icon: string;
}[] = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close" }
];
